const OFFER_CHECKOUT_EXTERNAL_REFERENCE_INITIATOR = 'Coaching::SchedulingHold';

interface PopupCheckoutEvent extends CustomEvent<{ offerToken: string }> {}

function launchPopupCheckout({
  externalReferenceId,
  offerToken,
}: {
  externalReferenceId: number | string;
  offerToken: string;
}) {
  // Prepare the params
  const href = `#popup_checkout_${offerToken}`;
  const popupCheckoutPayload = btoa(
    JSON.stringify({
      externalReference: {
        initiator: OFFER_CHECKOUT_EXTERNAL_REFERENCE_INITIATOR,
        id: String(externalReferenceId),
      },
    }),
  );

  // Check if there is an existing link with the exact payload already present
  const existingLink = document.querySelector(
    `[href="${href}"][data-popup-checkout="${popupCheckoutPayload}"]`,
  );
  if (existingLink instanceof HTMLAnchorElement) {
    existingLink.click();
    return;
  }

  // Append the new link to the page
  const link = document.createElement('a');
  link.innerHTML = 'Click me';
  link.href = href;
  link.style.cssText = 'display: none;';
  link.dataset.popupCheckout = popupCheckoutPayload;
  document.body.appendChild(link);

  // Bind a listener that will click the popup checkout link once ready
  document.addEventListener(
    'kjb:popupCheckout:onInit',
    (event: Event) => {
      const popupCheckoutEvent = event as PopupCheckoutEvent;
      if (popupCheckoutEvent.detail.offerToken === offerToken) {
        const mountedPopupCheckoutLink = document.querySelector(
          `[href="${href}"][data-popup-checkout]`,
        ) as HTMLElement;
        mountedPopupCheckoutLink.click();
      }
    },
    {
      once: true,
    },
  );

  // Dispatch an event to trigger popup checkout to mount on the newly appended link
  document.dispatchEvent(new CustomEvent('kjb:popupCheckout:init', { detail: { link } }));
}

export default launchPopupCheckout;
